import { Col } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setAudioCall, setVideoCall } from "../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../Utils";
import SocialInformation from "./SocialInformation";

const UserContactProfile = () => {
  const dispatch = useAppDispatch();
  const { activeContactUser } = useAppSelector((state) => state.messenger);
  const ActiveUser = activeContactUser.find((user) => user.active === true);

  return (
    <Col sm="5">
      <div className="user-profile">
        <div className="user-content">
          <Image className="img-fluid bg-icon" src={dynamicImage(`contact/${ActiveUser?.avatar}.jpg`)} alt="user-img" />
          <h3>{ActiveUser?.userName}</h3>
          <ul>
            <li><i className="fa fa-twitch" />massage</li>
            <li><i className="fa fa-phone" onClick={() => dispatch(setAudioCall())} />voice call</li>
            <li><i className="fa fa-video-camera" onClick={() => dispatch(setVideoCall())} />video call</li>
          </ul>
        </div>
      </div>
      <SocialInformation />
    </Col>
  );
};

export default UserContactProfile;
